module.exports = {
	path: '/activity',
	component: require('@views/Activity').default,
	props: (route) => {
		let filters = {};

		if (route.query.status) {
			filters.status = route.query.status;
		}

		if (Object.keys(filters).length) {
			return { filter: filters };
		}

		return {};
	},
	meta: {
		showButton: true,
		title: 'Activity',
		icon: ['far', 'chart-bar'],
		primary: true,
		search: {
			placeholder: 'Search Quotes & Orders',
			show: true,
		},
	},
};
